import { observer } from 'mobx-react';
import { ChatBotStore } from '../stores/chatBotStore';
import { Box, Chip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { StarBorderOutlined } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  suggestionsContainer: {
    display: 'flex',
    background: '#F7F8FC',
    backdropFilter: 'blur(10px)',
    width: '100%',
    transition: 'all 0.2s ease',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  suggestionChip: {
    backgroundColor: '#A4E0E9',
    padding: 0,
    transition: 'all 0.3s ease',
    '&:hover': {
      background: '#6FBCC6',
    },
    '&:disabled': {
      background: '#cbd5e1',
      boxShadow: 'none',
    },
    '& svg': {
      color: theme.palette.common.black,
    },
  },
}));

interface SuggestionsBlockProps {
  store: ChatBotStore;
}


export const SuggestionsBlock = observer(({ store }: SuggestionsBlockProps) => {
  const classes = useStyles();
  const suggestions = ['Loan status', ' Create ticket', 'Check Draws'];

  const handleSuggestionClick = async (suggestion: string) => {
    await store.sendMessage(suggestion);
  };

  return (
    <Box className={classes.suggestionsContainer}>
      {suggestions.map((suggestion, index) => (
        <Chip
          key={index}
          label={suggestion}
          icon={<StarBorderOutlined />}
          onClick={() => handleSuggestionClick(suggestion)}
          className={classes.suggestionChip}
        />
      ))}
    </Box>
  );
}
);
